<template>
    <div class="callNumDia">
        <div class="display-f just-b">
            <span class="size16 font600">{{ title }}</span>
            <i class="el-icon-close size16" @click="close"></i>

        </div>
        <div class="cur-warp">
            <div class="color6671 size14">当前就诊人</div>
            <div class="size20 font600 color1F23 mt12">{{ curPatient ? curPatient.patientName : '暂无' }}</div>
            <div class="display-f mt12 just-b">
                <custom-button class="btn" type="info" :disabled="(curPatient == null || curPatient == undefined)"
                    @click="overOrReNum('restart')">重呼</custom-button>
                <custom-button class="btn" type="info" :disabled="(curPatient == null || curPatient == undefined)"
                    @click="showOverNumDia = true">过号</custom-button>
            </div>
        </div>
        <custom-button class="mt8 next" type="primary" :disabled="(callOrderList.length == 0 || tabName != '2')"
            @click="callNextNum">
            呼叫下一位</custom-button>
        <div class="list-warp mt16">
            <el-tabs v-model="tabName" type="border-card" @tab-click="handleClick" stretch>
                <el-tab-pane v-for="item in tabList" :key="item.id"
                    :label="item.label + '(' + (item.id == 1 ? orderNumObj.staySignNum : item.id == 2 ? orderNumObj.staySeeNum : orderNumObj.alreadySeeNum) + ')'"
                    :name="item.id">
                </el-tab-pane>
            </el-tabs>
            <div class="list-content">
                <div v-if="callOrderList.length == 0" class="color6671 tac w100_ mt50">暂无患者</div>
                <div v-for="item in callOrderList" :key="item.registeredId" class="list">
                    <div v-if="item.signinPolicy=='signin_date' && tabName=='1'" class="listBox">签到后排号</div>
                    <div v-else class="listBox">{{  formatterType(item.timeType) }}{{ item.registeredCode }}号</div>
                    <div class="listBox" style="width: 140px;">
                      <div class="patient_user">
                        <span>{{ item.patientName }}</span>
                        <el-tooltip v-if="item.age >= 80" class="item" effect="dark" content="80岁以上老人" placement="top">
                            <img class="patient_user_older" :src="imgArr.call_older" />
                        </el-tooltip>
                      </div>
                      <div v-if="item.preExamineFlag =='1'" class="listBox-label">已预诊</div>
                    </div>
                    <div class="listBox" style="width: 80px;">{{ item.isIncrease ? `${formatterRegisterType(item.registerType)}加号` : formatterRegisterType(item.registerType) }}</div>
                    <div class="listBox" style="width: 60px;">{{ item.signinTime ? $moment(item.signinTime).format('HH:mm') : '-' }}</div>
                    <custom-button class="btn" type="primary" plain v-if="tabName == '2'" :disabled="(curPatient && curPatient.registeredId == item.registeredId)" @click="callNum(item)">呼叫</custom-button>
                </div>
            </div>
        </div>
        <custom-dialog width="358px" type="info" :showClose="true" title="信息提示" :visible="showOverNumDia"
            :modal-append-to-body='false' v-if="showOverNumDia" @close="closeDia" @save="overOrReNum('over')">
            <div slot="content">
                当前就诊的{{ curPatient.patientName }}未完成接诊，是否确定过号？
            </div>
        </custom-dialog>
        <custom-dialog width="358px" type="info" :showClose="true" title="信息提示" :visible="callNumDia"
            :modal-append-to-body='false' v-if="callNumDia" @close="closeDia" @save="callNum()">
            <div slot="content">
                当前就诊的{{ curPatient.patientName }}未完成接诊，是否确定进行呼叫？
            </div>
        </custom-dialog>
    </div>
</template>
  
<script>
import CustomDialog from '@/components/customDialog/CustomDialog'
import { registerDTO, orderDTO } from '@/DTO/index'

import { schedulingTypeList, outpatientTypeAbbrList } from '@/utils/const'
import { dictText,debounce } from "@/utils/validateBase";
import { Common } from "../data/index.js";
import { imgArr } from '../../../../assets/images/img.js';
export default {
    // 定义引入的组件
    components: { CustomDialog },
    props: {
        title: {
            type: String,
            default: ''
        },
        callNumObj: {
            type: Object,
            default: () => { return {} }
        },
    },
    data() {
        return {
            imgArr: imgArr,
            callListObj: this.callNumObj,
            callOrderList: [],
            tabList: [
                { id: '1', label: '待签' },
                { id: '2', label: '待诊' },
                { id: '3', label: '已诊' },
            ],
            tabName: '2',//默认选中待诊
            orderNumObj: {},
            schedulingTypeList: schedulingTypeList,
            outpatientTypeAbbrList: outpatientTypeAbbrList,
            curPatient: null,//当前就诊人
            showOverNumDia: false,
            isCallNext: false,//是否呼叫下一位
            nextCall: null,//下一位呼叫的人
            callNumDia:false,
            isNext:false
        }
    },
    //变量监听
    watch: {
    },
    // 页面初始化
    created() {
    },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        init() {
            this.getCallOrderNum();
            //获取叫号列表
            this.getCallNumList()
            //获取当前就诊人
            // this.getCallNumList(1)
        },

        //获取叫号列表
        close() {
            this.$emit('closeCallNum')
        },
        //切换标签
        handleClick(tab, event) {
            console.log(tab, event);
            this.getCallNumList()
        },
        callNextNum(){
            if (this.curPatient) {
                this.isNext=true
                this.callNumDia = true;
            }else{
                this.callNum()
            }

        },
        //获取待诊就诊数量
        async getCallOrderNum() {
            let params = {
                isReplenish: '0',
                deptId: this.callNumObj.deptId,
                doctorId: this.callNumObj.doctorId,
                startTime:this.$moment().format('YYYY-MM-DD'),
                stopTime: this.$moment().format('YYYY-MM-DD'),
            }
            let { code, data } = await registerDTO.getRegisterStatusNum(params)
            if (code == 200) {
                this.orderNumObj = data
                console.log('this.orderNumObj', this.orderNumObj);
            }
        },
        async getCallNumList(isVisiting) {
            let obj = {
                deptId: this.callNumObj.deptId,
                doctorId: this.callNumObj.doctorId,
                date: this.$moment().format('YYYY-MM-DD'),
                status: this.tabName
            }
            // if (isVisiting) {
            //     obj.isVisiting = isVisiting
            // }
            console.log('v', obj);
            let { code, rows, total } = await orderDTO.callNumListDTO(obj)
            if (code == 200 ) {
                    this.callOrderList = rows
                    let info=rows[0]
                    if(this.tabName=='2' && info.isVisiting=='1'){
                        this.curPatient=info
                    }else if(this.tabName=='2' && info.isVisiting!='1'){
                        this.curPatient=null
                    }
            }
            // if (this.isCallNext && !isVisiting) {
            //     this.callNum()
            //     this.isCallNext = false
            // }
        },
        //叫号
        callNum: debounce(async function (row) {
            if (this.curPatient && !this.isNext) {
                this.showOverNumDia = true;
                this.isCallNext = true;
                if (row) {
                    this.nextCall = row
                }
                return false;
            }
            const { deptId, doctorId } = this.callNumObj
            let registeredId
            if (row) {
                registeredId = row.registeredId
            } else {
                // registeredId = this.callOrderList[0].registeredId
            }
            let obj = {
                deptId, doctorId, registeredId
            }
            let res = await orderDTO.callNumDTO(obj)
            if (res.code == 200) {
                this.isNext=false
                this.callNumDia=false
                this.$message.success('正在呼叫当前就诊人')
                this.$emit('callNum',res.data.registeredId)
                this.init()
                window.$trackTool.track({ v: '1', b: 'his_000002', t: 'his_0001' }, { updateTime: new Date(window.$systemTime).Format('yyyy-MM-dd hh:mm:ss'), orderId: res.data.registeredId })
            }
        }, 500,true),
        overOrReNum: debounce(async function (type) {
            const { deptId, doctorId } = this.callNumObj
            let obj = {
                deptId, doctorId
            }
            if (type == 'over') {
                let res = await orderDTO.overNumberedDTO(obj)
                if (res.code == 200) {
                    this.curPatient = null
                    if (this.nextCall) {
                        this.callNum(this.nextCall)
                        this.nextCall = null;
                        this.isCallNext = false
                    } else {
                        this.init()
                    }

                }
                this.showOverNumDia = false
            }
            if (type == 'restart') {
                let res = await orderDTO.restartCallDTO(obj)
                if (res.code == 200) {
                    this.$message.success('正在呼叫当前就诊人')
                    window.$trackTool.track({ v: '1', b: 'his_000002', t: 'his_0001' }, { updateTime: new Date(window.$systemTime).Format('yyyy-MM-dd hh:mm:ss'), orderId: res.data.registeredId })
                }
            }
        }, 500,true),
        closeDia() {
            this.showOverNumDia = false
            this.callNumDia=false
            this.nextCall = null
        },
        /**
     * 处理班次类型
     */
        formatterType(type) {
            return dictText(type, schedulingTypeList)
        },
        /**
     * 处理挂号类型
     */
        formatterRegisterType(type) {
            return dictText(type, outpatientTypeAbbrList)
        },
    },
}
</script>
<style lang="less" scoped>
.callNumDia {
    width: 100%;
    height: 476px;

    .cur-warp {
        text-align: center;
        margin-top: 12px;
        width: 100%;
        border-radius: 2px 2px 2px 2px;
        background: #E8F4FF;
        height: 138px;
        display: flex;
        flex-direction: column;
        padding: 16px 24px;
        box-sizing: border-box;

        font-size: 14px;

        .btn {

            text-align: center;
            color: #1F2329;
            width: 138px;
            height: 32px;
            border-radius: 2px 2px 2px 2px;
            border: 1px solid #D3D3D5;
        }

        .disBtn {
            pointer-events: none;
            text-align: center;
            color: #B8B8B8;
            background: #F5F5F5;
            border: 1px solid #D9D9D9;
        }

    }

    .next {
        text-align: center;
        font-size: 14px;
        height: 32px;
        border-radius: 2px 2px 2px 2px;
        width: 100%;
    }

    .disNext {
        pointer-events: none;
        height: 32px;
        background: #8BC7FF;
        border-radius: 2px 2px 2px 2px;
    }

    .list-warp {
        width: 100%;
        // height: 218px;
        border-radius: 2px 2px 2px 2px;
        border: 1px solid #EBEAEE;

        .list-content {
            height: 185px;
            overflow-y: auto;
        }

        .list {
            padding: 6px 12px;
            border-bottom: 1px solid #EBEAEE;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .listBox {
                width: 100px;
                text-align: left;
                display: flex;
                align-items: center;
                overflow: hidden;
                text-overflow: ellipsis;
                -webkit-line-clamp: 1;
                white-space: nowrap; //文本不会换行
                cursor: pointer;
            }
            .listBox-label{
              font-size: 12px;
              color: #1890FF;
              margin-left: 2px;
            }
            .btn {
                height: 24px;
                width: 44px;
                padding: 0px;
            }

            .overBox {
                font-size: 12px;
                line-height: 18px;
                color: #FE8F1F;
                padding: 0px 4px;
                height: 18px;
                background: #FFF0E1;
                border-radius: 2px 2px 2px 2px;
            }
        }
    }

    /deep/.el-tabs {
        border: none;
        margin-bottom: 0px;
    }

    /deep/.el-tabs--border-card {
        border: none;
        box-shadow: none;
    }

    /deep/.el-tabs--border-card>.el-tabs__header {
        border: none;
    }

    /deep/.el-tabs .el-tabs__header {
        padding-left: 0px;
    }
}

.patient_user {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.patient_user_older {
    margin: 0 0 0 4px;
    width: 16px;
    height: 16px;
}

</style>